import { useFeatureFlag, type IFeatureFlag } from "@/api/FeatureFlags";
import { Navigate } from "react-router";
import { Loading } from "@medoma/components/Loading/Loading";
import { useLingui } from "@lingui/react/macro";

const FeatureFlag = ({
  children,
  feature,
}: {
  children: React.ReactNode;
  feature: IFeatureFlag["name"];
}) => {
  const { t } = useLingui();
  const { data: flagIsEnabled, isPending } = useFeatureFlag(feature);

  if (isPending) {
    return <Loading message={t`Laddar`} />;
  }

  if (!flagIsEnabled) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default FeatureFlag;
